import { useEffect, useState } from 'react';

const useModal = ( data, modalRef, context ) => {
  const [ modalData, setModalData ] = useState( [] );
  const [ modalClass, setModalClass ] = useState( 'js-closed' );
  const [ modalType, setModalType ] = useState( null );
  const getISBN = ( item ) => item?.isbn || item?.isbnStr;

  const [ activeEl, setActiveEl ] = useState( document.activeElement );

  const modalIsOpen = modalClass === 'js-opened';

  const onClickOpenModal = ( id, type ) => {
    setModalType( type );
    setModalData(
      data.find( ( item ) => {
        const itemIsbn = getISBN( item );
        // eslint-disable-next-line eqeqeq
        return context.featureBy === 'books' ? itemIsbn == id : item?.authorId == id;
      })
    );
    setModalClass( 'js-opened' );
    setActiveEl( document.activeElement );
  };

  const onClickCloseModal = () => {
    setModalClass( 'js-closed' );
  };

  const onKeyPressModal = ( e ) => {
    if ( e.key === 'Escape' ) {
      setModalClass( 'js-closed' );
      activeEl.focus();
    }
    if ( e.key === 'Tab' ) {
      const focusableEls = document.querySelectorAll( '.js-opened a:not(.logo-button), .js-opened textarea, .js-opened input[type="radio"], .js-opened button' );
      const firstFocusable = focusableEls[0];
      const lastFocusable = focusableEls[ focusableEls.length - 1 ];
      let tabInModal = false;
      for ( var i = 0; i < focusableEls.length; i++ ) {
        if ( document.activeElement === focusableEls[i] ){
          tabInModal = true;
          break;
        }
      }
      if ( e.shiftKey ){
        if( document.activeElement === firstFocusable ){
          lastFocusable.focus();
          e.preventDefault();
          return;
        }
      } else {
        if ( document.activeElement === lastFocusable || !tabInModal ){
          firstFocusable.focus();
          e.preventDefault();
          return;
        }
      }
    }
    if ( e.key === 'Enter' && e.target.classList.contains( 'modal__btn--close' ) ) {
      setModalClass( 'js-closed' );
      activeEl.focus();
      e.preventDefault();
    }
  };

  const onClickOffModal = ( e ) => {
    if (
      modalIsOpen &&
            modalRef.current &&
            !modalRef.current.contains( e.target )
    ) {
      setModalClass( 'js-closed' );
    }
  };

  useEffect( () => {
    document.body.classList.toggle( 'is-open-modal', modalIsOpen );
    if ( modalIsOpen ) {
      document.addEventListener( 'mousedown', onClickOffModal );
      document.addEventListener( 'keydown', onKeyPressModal );
      setTimeout( () => {
        let closeButton = document.querySelectorAll( '.js-opened .modal__btn--close' )[0];
        if ( closeButton ){
          closeButton.focus({ focusVisible: true });
        }
      }, 100 );
    }
    return () => {
      document.removeEventListener( 'mousedown', onClickOffModal );
      document.removeEventListener( 'keydown', onKeyPressModal );
    };
  }, [ modalClass ] );

  return {
    modalData,
    modalClass,
    modalType,
    onClickOpenModal,
    onClickCloseModal
  };
};

export default useModal;
